import { render, staticRenderFns } from "./FormLineReadOnly.vue?vue&type=template&id=23a0ec70&scoped=true&"
import script from "./FormLineReadOnly.vue?vue&type=script&lang=js&"
export * from "./FormLineReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./FormLineReadOnly.vue?vue&type=style&index=0&id=23a0ec70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a0ec70",
  null
  
)

export default component.exports